export default {
  title: 'Promokodedetaljer',
  back: 'Tilbage til promokoder',
  tabs: {
    customers: 'Kunder',
    orders: 'Ordrer',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Gns. ordreværdi',
    customer_adoption: 'Unikke kunder',
  },
  toasts: {
    failed_to_load_stats: 'Statistik kunne ikke indlæses',
  },
};
